import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private _storage: Storage | null = null;
  private initialized = false;

  constructor() {}

  // initialize local storage
  async init() {
    if (!this.initialized) {
      this._storage = window.localStorage;
      this.initialized = true;
    }
    return Promise.resolve();
  }

  public set(key: string, value: any) {
    if (this._storage) {
      this._storage.setItem(key, JSON.stringify(value));
      return Promise.resolve();
    }
    return Promise.reject('Storage not initialized');
  }

  public async get(key: string) {
    if (this._storage) {
      const item = this._storage.getItem(key);
      return item ? JSON.parse(item) : null;
    }
    return Promise.reject('Storage not initialized');
  }

  public async remove(key: string) {
    if (this._storage) {
      this._storage.removeItem(key);
      return Promise.resolve();
    }
    return Promise.reject('Storage not initialized');
  }

  public keys() {
    if (this._storage) {
      return Object.keys(this._storage);
    }
    return [];
  }
}
